import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';
import { appointmentDraftActions } from '~/api';

import { Button } from '~/elements';
import { errorTypes } from '~/components';
import { setHeadlineBackButtonConfig } from '~/ocab-services/services.actions';
import { routerSelectors } from '~/selectors';
import { isEmpty } from '~/utils';

export class AppointmentTypeNotFoundMessage extends PureComponent {
  componentDidMount() {
    const {
      history,
      locationErrorState,
      navigateToSelectTreatment,

      dispatchSetPartnersGroupId,
      dispatchSaveAppointmentDraft,
      dispatchResetAppointmentType,
      dispatchSetHeadlineBackButtonConfig,
      dispatchApiCallFinished,
    } = this.props;

    if (isEmpty(locationErrorState)) {
      history.replaceWithToken({
        state: {
          error: {
            isError: true,
            type: errorTypes.APPOINTMENT_TYPE_NOT_FOUND,
          },
        },
      });
    }

    dispatchSetHeadlineBackButtonConfig({
      isDisplayed: true,
      title: 'Select treatment',
      goBack: navigateToSelectTreatment,
    });

    Promise.all([
      dispatchSetPartnersGroupId(''),
      dispatchResetAppointmentType(),
      dispatchSaveAppointmentDraft(),
    ]).then(() => {
      dispatchApiCallFinished(true);
    });
  }

  render() {
    const { navigateToSelectTreatment } = this.props;

    return (
      <Button view="primary" inline onClick={navigateToSelectTreatment}>
        Go back to treatments
      </Button>
    );
  }
}

export const mapStateToProps = (state) => ({
  locationErrorState: routerSelectors.selectLocationErrorState(state),
});

const mapDispatchToProps = {
  dispatchSetPartnersGroupId: appointmentDraftActions.setPartnersGroupId,
  dispatchSetHeadlineBackButtonConfig: setHeadlineBackButtonConfig,
  dispatchSaveAppointmentDraft: appointmentDraftActions.saveAppointmentDraft,
  dispatchResetAppointmentType: appointmentDraftActions.resetAppointmentType,
};

export const ConnectedAppointmentTypeNotFoundMessage = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppointmentTypeNotFoundMessage),
);

AppointmentTypeNotFoundMessage.propTypes = {
  locationErrorState: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  navigateToSelectTreatment: PropTypes.func.isRequired,

  dispatchSetPartnersGroupId: PropTypes.func.isRequired,
  dispatchSetHeadlineBackButtonConfig: PropTypes.func.isRequired,
  dispatchSaveAppointmentDraft: PropTypes.func.isRequired,
  dispatchResetAppointmentType: PropTypes.func.isRequired,
  dispatchApiCallFinished: PropTypes.func.isRequired,
};
